import { click } from '@testing-library/user-event/dist/click';
import React from 'react'
import {useState} from 'react';
import Draggable from 'react-draggable';
import { useSelector, useDispatch } from 'react-redux'
import { selectBorder, deselectBorder } from '../slices/mbSelectSlice'
import { startWindow, showWindow, hideWindow, focusWindow } from '../slices/mwSelectSlice';
import Window from './Window';

const MenuButton = ({text, mbType}) => {
  const selected_button = useSelector((state) => state.selector)
  const dispatch = useDispatch()
  const div_name = 'button-div'
  const div_handle ='.button-div'
  const window_name = mbType.replace('-button','') + '-window'
  const window_div = useSelector((state) => state.shower)
  
  const mbOnClick = () => {
    if(selected_button.value !== mbType){
      dispatch(deselectBorder())
      dispatch(selectBorder(mbType))
    }else if(selected_button.value === mbType && selected_button.highlight){
      if(window_div.window.find((w) => w.windowID === window_name).display == 'none'){
        dispatch(startWindow(window_name))
      }
      dispatch(focusWindow(window_name))
      dispatch(deselectBorder())
    }
  }
  const [hoverState, setHover] = useState(false) 
  
  const setHoverTrue = () => {
    setHover(true)
  }
  
  const setHoverFalse = () => {
    setHover(false)
  }
  
  
  
  return (

    <Draggable zIndex={-1} handle='.handle'>
      <div id={div_name} className='handle'>
        <button className={'menu-button'} onMouseEnter={setHoverTrue} onMouseLeave={setHoverFalse} onClick={mbOnClick}
        style={
          {display: 'block',
          backgroundColor: hoverState ? 'rgba(51, 204, 255, 0.5)': (selected_button.value === mbType && selected_button.highlight) ? 'rgba(51, 204, 255, 0.3)' : 'transparent',
          width: '80px',
          height: '100px',
          textAlign: 'center',
          marginLeft: '18px',
          lineHeight: '0px',
          border: 'none',
          cursor: 'pointer',}
          }>
          <div id={mbType}/>
          <p style={{paddingTop: '0px', fontFamily: '"MS Sans Serif"', fontSmooth: 'never',color: 'white', textShadow: '1px 2px black'}}>
            {text}
          </p>
        </button>

      </div>

    </Draggable>
    )
  }
  
  export default MenuButton